"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textSearchCompareByWord = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var textSearchCompareByWord = function textSearchCompareByWord(search, text) {
  return !search || _lodash.default.every(search.split(' '), function (word) {
    return text.toLowerCase().includes(word.toLowerCase());
  });
};

exports.textSearchCompareByWord = textSearchCompareByWord;